import React, { useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import NotificationAlert from "react-notification-alert";
import axios from 'axios';
import Cookies from 'js-cookie';

import * as constants from 'constants/index.js';
import CardsHeader from 'layouts/Headers/CardsHeader.js';

import TableCustom from 'views/pages/components/TableCustom';
import InputCustom from 'views/pages/components/InputCustom';

import {
  Container,
  Row,
  Col,
  Card,
  CardHeader,
  CardBody,
  Button,
  Modal,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  FormGroup,
} from 'reactstrap';

import {
  update,
  deletee,
  hasPermission
} from 'views/policies/BusinessActivityPolicy';

export default function BusinessActivity() {
  const notificationAlert = useRef(null);
  const history = useHistory();

  const permissions = useSelector(state => state.getState).permissions;

  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(true);
  const [activities, setActivities] = useState([]);
  const [statuses, setStatuses] = useState([]);

  const [activity, setActivity] = useState('');
  const [activityModal, setActivityModal] = useState({
    show: false,
    header: '',
    division: ''
  })

  const [deleteModal, setDeleteModal] = useState({
    show: false,
    header: '',
    body: '',
    onClick: null
  });

  const [errors, setErrors] = useState('');

  const notify = (type, header, message) => {
    let options = {
      place: "tc",
      message: (
        <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {" "}
            {header}
          </span>
          <span data-notify="message">
            <div dangerouslySetInnerHTML={{ __html: message }} />
          </span>
        </div>
      ),
      type: type,
      icon: "ni ni-bell-55",
      autoDismiss: 5
    };
    notificationAlert.current.notificationAlert(options);
  };

  useEffect(() => {
    const grs_token = Cookies.get('grs_token')
    setToken(grs_token)

    const source = axios.CancelToken.source()

    const fetchData = async () => {
      try {
        const response = await axios({
          method: 'GET',
          url: `${constants.API_URL}/business-activity`,
          headers: {
            Authorization: `Bearer ${grs_token}`,
          },
          cancelToken: source.token,
        })
        console.log('response :: ', response.data)
        const data = response.data
        
        setActivities(data.data.activities)
        setStatuses(data.data.statuses)

        setTimeout(() => {
          setLoading(false)
        }, 500);
      } catch (error) {
        setLoading(false)
        if (axios.isCancel(error)) {
          console.log('Request canceled :: ', error)
        } else {
          console.error('error :: ', error)
          notify('warning', 'Warning', error.response && error.response.data ? error.response.data.message : error.response ? error.response.statusText : 'Error Occurred!')
        }
      }
    }

    fetchData()

    return () => {
      source.cancel()
    }
  }, [])

  const addActivity = () => {
    axios({
      method: 'POST',
      url: `${constants.API_URL}/business-activity`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: activity
    })
      .then(response => {
        setErrors('')
        setActivityModal({
          ...activityModal,
          show: false
        })
        setActivity('')
        console.log('res :: ', response.data)
        let data = response.data
        setActivities(data.data)
        notify('success', 'Success', data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status == 422) {
          setErrors(error.response.data.errors)
          return
        }
        setActivityModal({
          ...activityModal,
          show: false
        })
        notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const updateActivity = () => {
    axios({
      method: 'PUT',
      url: `${constants.API_URL}/business-activity/${activity.id}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
      data: activity
    })
      .then(response => {
        setErrors('')
        setActivityModal({
          ...activityModal,
          show: false
        })
        setActivity('')
        console.log('res :: ', response.data)
        let data = response.data
        setActivities(data.data)
        notify('success', 'Success', data.message)
      })
      .catch(error => {
        setErrors('')
        console.error('error :: ', error)
        if (error.response && error.response.status == 422) {
          setErrors(error.response.data.errors)
          return
        }
        setActivityModal({
          ...activityModal,
          show: false
        })
        notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  const deleteActivity = (activityId) => {
    axios({
      method: 'DELETE',
      url: `${constants.API_URL}/business-activity/${activityId}`,
      headers: {
        Authorization: `Bearer ${token}`
      },
    })
      .then(response => {
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        console.log('res :: ', response.data)
        let data = response.data
        setActivities(data.data)
        notify('success', 'Success', data.message)
      })
      .catch(error => {
        console.error('error :: ', error)
        setDeleteModal({
          ...deleteModal,
          show: false
        })
        notify('warning', 'Warning', error.response ? error.response.statusText : 'Error occurred!')
      })
  }

  return (
    <>
      <CardsHeader name="Settings" parentName="Business Activities Management" currentName="List" />
      <div className="rna-wrapper">
        <NotificationAlert ref={notificationAlert} />
      </div>
      <Container className="mt--5 admin-main-body" fluid >
        <Row>
          <Col xl="12">
            <Card>
              <CardHeader>
                <Row>
                  <Col xs={8}>
                    <h1 className="mb-0">Business activities</h1>
                    <p className="text-sm mb-0">You can manage Business activities.</p>
                  </Col>
                  <Col xs={4} className="text-right">
                    <Button className="w-100" color="success" type="button" onClick={() => setActivityModal({
                      ...activityModal,
                      show: true,
                      header: 'Add business activity',
                      division: 'create'
                    })}>Add business activity</Button>
                  </Col>
                </Row>
              </CardHeader>
              <CardBody>
                <TableCustom
                  loading={loading}
                  keyField={`id`}
                  searchField={false}
                  items={activities}
                  columns={[
                    {
                      dataField: "name",
                      text: "Name",
                      sort: true
                    },
                    {
                      dataField: "status",
                      text: "Status",
                      sort: true,
                      formatter: (rowContent, row) => {
                        return statuses[row.status]
                      }
                    },
                    {
                      dataField: "",
                      text: "Action",
                      formatter: (rowContent, row) => {
                        return (
                          <>
                            {(hasPermission(permissions, 'update-business-activities') || hasPermission(permissions, 'delete-business-activities')) &&
                              <UncontrolledDropdown>
                                <DropdownToggle
                                  className="btn-icon-only text-light"
                                  color=""
                                  role="button"
                                  size="sm"
                                >
                                  <i className="fas fa-ellipsis-v" />
                                </DropdownToggle>
                                <DropdownMenu className="dropdown-menu-arrow" right>
                                  {update(permissions, row) &&
                                    <DropdownItem
                                      onClick={e => {
                                        setActivity(row)
                                        setActivityModal({
                                          ...activityModal,
                                          show: true,
                                          header: 'Edit business activity',
                                          division: 'udpate'
                                        })
                                      }}
                                    >
                                      Edit
                                </DropdownItem>}
                                  {deletee(permissions, row) &&
                                    <DropdownItem
                                      onClick={e => setDeleteModal({
                                        ...deleteModal,
                                        show: true,
                                        header: 'Delete business activity',
                                        body: 'Are you sure you want to delete this business activity?',
                                        onClick: () => deleteActivity(row.id)
                                      })}
                                    >
                                      Delete
                                </DropdownItem>}
                                </DropdownMenu>
                              </UncontrolledDropdown>}
                          </>
                        )
                      }
                    }
                  ]}
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
        <Modal
          isOpen={activityModal.show}
          toggle={() => setActivityModal({
            ...activityModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{activityModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setActivityModal({
                ...activityModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            <InputCustom
              label={`Name`}
              value={activity && activity.name ? activity.name : ''}
              onChange={e => setActivity({
                ...activity,
                name: e.target.value,
              })}
              invalid={errors && errors.name ? true : false}
              errorMessage={errors.name}
            />
            <FormGroup>
              <div>
                <label className="form-control-label">Status</label>
              </div>
              {
                statuses.map((status, index) => {
                  return (
                    <div className="custom-control custom-radio" key={index}>
                      <input
                        className="custom-control-input"
                        id={index}
                        name="customRadioInline1"
                        type="radio"
                        checked={index == activity.status ? true : false}
                        onChange={() => setActivity({
                          ...activity,
                          status: index
                        })}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={index}
                        onClick={() => setActivity({
                          ...activity,
                          status: index
                        })}
                      >
                        {status}
                      </label>
                    </div>
                  )
                })
              }
            </FormGroup>
            <div className="invalid-feedback" style={{ display: errors && errors.status ? 'block' : 'none' }}>
              {errors.status}
            </div>
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="primary"
              type="button"
              onClick={() => activityModal.division == 'create' ? addActivity() : updateActivity()}
            >
              {`Save`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setActivityModal({
                ...activityModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
        <Modal
          isOpen={deleteModal.show}
          toggle={() => setDeleteModal({
            ...deleteModal,
            show: false
          })}
          className="modal-dialog-centered"
        >
          <div className="modal-header">
            <h6 className="modal-title">{deleteModal.header}</h6>
            <button
              aria-label="Close"
              className="close"
              data-dismiss="modal"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              <span aria-hidden={true}>×</span>
            </button>
          </div>
          <div className="modal-body">
            {`Are you sure you want to delete this business activity?`}
          </div>
          <div className="modal-footer">
            <Button
              className="new-event--add"
              color="danger"
              type="button"
              onClick={deleteModal.onClick}
            >
              {`Delete`}
            </Button>
            <Button
              className="ml-auto"
              color="link"
              type="button"
              onClick={() => setDeleteModal({
                ...deleteModal,
                show: false
              })}
            >
              {`Close`}
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}